import { getDefaultIntegrations, init as init$1 } from '@sentry/browser';
import { applySdkMetadata } from '@sentry/core';

/**
 * Initializes the client-side of the Nuxt SDK
 *
 * @param options Configuration options for the SDK.
 */
function init(options) {
  const sentryOptions = {
    /* BrowserTracing is added later with the Nuxt client plugin */
    defaultIntegrations: [...getDefaultIntegrations(options)],
    ...options,
  };

  applySdkMetadata(sentryOptions, 'nuxt', ['nuxt', 'vue']);

  return init$1(sentryOptions);
}

export { init };
//# sourceMappingURL=sdk.js.map
